module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insights"
  }, [_c('div', {
    staticClass: "insights__tabs"
  }, [_c('div', {
    staticClass: "insights__headerRow"
  }, [_c('div', {
    staticClass: "insights__headerRow__tabName"
  }, [_vm._v(_vm._s(_vm.insightsHeaderText))]), _vm._v(" "), _c('div', {
    staticClass: "insights__headerRow__audienceExpansion"
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "hide-details": "",
      "dense": "",
      "inset": "",
      "disabled": _vm.viewOnly || !_vm.allowAudienceExpansionToggle
    },
    on: {
      "change": _vm.onAudienceExpansionToggle
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticClass: "audience-expansion-label",
          class: {
            'audience-expansion-label--active': _vm.audienceExpansion
          }
        }, [_vm._v("\n              Audience Expansion\n            ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.audienceExpansion),
      callback: function($$v) {
        _vm.audienceExpansion = $$v
      },
      expression: "audienceExpansion"
    }
  })], 1)]), _vm._v(" "), _c('scroll-panel', {
    staticClass: "insights__tabular-area"
  }, [_c('primary', {
    attrs: {
      "primaryInsights": _vm.workbenchSlottedValue || undefined,
      "loadingInsights": _vm.loadingInsights,
      "loadingWorkbench": _vm.loadingWorkbench
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "insights__tabs__insightButtonRow"
  }, [_c('interactive-simple-button', {
    attrs: {
      "disabled": _vm.disableUpdateInsights,
      "label": _vm.buttonText
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateInsights.apply(null, arguments)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6912f678"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/insights/Insights.vue
// module id = 1926
// module chunks = 0